import { api } from '../api/client'
import type { BrandingRecord } from '../api/types'
import { readLocal, writeLocal } from '../data/browser'
import defaults from '../../branding.default.json'

const META_KEY = 'branding'

export const DEFAULT_BRANDING: BrandingRecord = {
  productName: defaults.productName,
  shortName: defaults.shortName,
  descriptor: defaults.descriptor,
  creditLine: defaults.creditLine,
  supportEmail: defaults.supportEmail,
  supportPhone: defaults.supportPhone || null,
  themeColor: defaults.themeColor,
  backgroundColor: defaults.backgroundColor,
  canonicalOrigin: '',
  originMigration: { enabled: false, newOrigin: null },
  offlineGraceDays: 7,
}

const listeners = new Set<(record: BrandingRecord) => void>()

/** Told whenever a fresh record arrives from the API. */
export function onBrandingFetched(listener: (record: BrandingRecord) => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/**
 * The record this browser last saw, so the sign-in screen shows a server-edited credit line
 * rather than flashing the built-in defaults.
 */
export async function loadCachedBranding(): Promise<BrandingRecord | null> {
  return readLocal<BrandingRecord>(META_KEY) ?? null
}

export async function fetchBranding(): Promise<BrandingRecord> {
  const { data } = await api.get<BrandingRecord>('/api/v1/platform/branding', { scope: null })
  const record: BrandingRecord = { ...DEFAULT_BRANDING, ...data }
  writeLocal(META_KEY, record)
  for (const listener of listeners) listener(record)
  return record
}
